import axios from "axios";

const socketUrl = import.meta.env.VITE_SOCKET_URL?.replace("/omni", "") || "";

const lsUser = JSON.parse(localStorage.getItem("user") || "{}");

const httpClientSocket = axios.create({
  baseURL: socketUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-user-id": lsUser ? lsUser.id : "",
  },
});

export default httpClientSocket;
